import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

export default function IconQuestionMark(props: SvgIconProps) {
  return (
    <SVGIcon xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="#d5d5d5" {...props}>
      <path
        d="M9.32955 10.789H8.32955C8.31818 10.6518 8.31818 10.5375 8.31818 10.3889C8.31818 9.63444 8.59091 9.06288 9.26136 8.60563L9.76136 8.2627C10.1477 7.99978 10.3636 7.58826 10.3636 7.14244C10.3636 6.468 9.92045 5.83929 9.01136 5.83929C8.02273 5.83929 7.59091 6.58231 7.59091 7.30248C7.59091 7.49681 7.625 7.73686 7.67045 7.86261L6.56818 7.72543C6.52273 7.5654 6.5 7.3825 6.5 7.17674C6.5 6.12507 7.26136 4.83334 9.01136 4.83334C10.6023 4.83334 11.5 5.96503 11.5 7.13101C11.5 8.04551 11 8.67422 10.3409 9.12004L9.81818 9.4744C9.46591 9.71446 9.31818 10.126 9.31818 10.5718C9.31818 10.629 9.31818 10.6747 9.32955 10.789ZM8.07955 12.4236C8.07955 12.0121 8.40909 11.6692 8.81818 11.6692C9.22727 11.6692 9.56818 12.0121 9.56818 12.4236C9.56818 12.8352 9.22727 13.1667 8.81818 13.1667C8.40909 13.1667 8.07955 12.8352 8.07955 12.4236Z"
        fill="currentColor"
      />
    </SVGIcon>
  );
}
